import { c as _c } from "react/compiler-runtime";
import { SPARTAN_PRODUCT_ENGINE_SPEC_UNITS } from '@/app/lcv/components/sections/spartan/products/engine/constants';
import { SpartanProductEngineDescriptionStyled, SpartanProductEngineRemarkStyled, SpartanProductEngineSpecLabelStyled, SpartanProductEngineSpecStyled, SpartanProductEngineSpecUnitStyled, SpartanProductEngineSpecValueStyled, SpartanProductEngineTitleStyled } from '@/app/lcv/components/sections/spartan/products/engine/styles';
import { SPARTAN_PRODUCT_ENGINE_TRACKING } from '@/app/lcv/components/sections/spartan/products/engine/tracking';
import styles from '@/app/lcv/components/sections/spartan/products/engine/view/panel/styles.module.css';
import type { SpartanProductEnginePanelProps } from '@/app/lcv/components/sections/spartan/products/engine/view/panel/types';
import { SharedAnimatedValue } from '@/app/lcv/components/sections/spartan/shared/animated-value';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export const SpartanProductEnginePanel = t0 => {
  const $ = _c(39);
  const {
    engine,
    index,
    theme: t1,
    active: t2
  } = t0;
  const theme = t1 === undefined ? "dark" : t1;
  const active = t2 === undefined ? true : t2;
  let t3;
  if ($[0] !== index) {
    t3 = createDataAttributes({
      test: SPARTAN_PRODUCT_ENGINE_TRACKING.item(index)
    });
    $[0] = index;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== theme) {
    t4 = SpartanProductEngineTitleStyled({
      theme
    });
    $[2] = theme;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== engine.title) {
    t5 = {
      __html: engine.title
    };
    $[4] = engine.title;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== index) {
    t6 = createDataAttributes({
      test: SPARTAN_PRODUCT_ENGINE_TRACKING.itemTitle(index)
    });
    $[6] = index;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t5 || $[10] !== t6) {
    t7 = <h3 className={t4} dangerouslySetInnerHTML={t5} {...t6} />;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== theme) {
    t8 = SpartanProductEngineDescriptionStyled({
      theme
    });
    $[12] = theme;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== engine.description) {
    t9 = {
      __html: engine.description
    };
    $[14] = engine.description;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== index) {
    t10 = createDataAttributes({
      test: SPARTAN_PRODUCT_ENGINE_TRACKING.itemDescription(index)
    });
    $[16] = index;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t8 || $[20] !== t9) {
    t11 = <div className={t8} dangerouslySetInnerHTML={t9} {...t10} />;
    $[18] = t10;
    $[19] = t8;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== engine.panelRemark || $[23] !== index || $[24] !== theme) {
    t12 = !!engine.panelRemark && <div className={SpartanProductEngineRemarkStyled({
      theme
    })} dangerouslySetInnerHTML={{
      __html: engine.panelRemark
    }} {...createDataAttributes({
      test: SPARTAN_PRODUCT_ENGINE_TRACKING.itemPanelRemark(index)
    })} />;
    $[22] = engine.panelRemark;
    $[23] = index;
    $[24] = theme;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11 || $[27] !== t12 || $[28] !== t7) {
    t13 = <div className="where-span:text-inline-wrap space-y-1">{t7}{t11}{t12}</div>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t7;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== active || $[31] !== engine.specs || $[32] !== index || $[33] !== theme) {
    t14 = !!engine.specs.length && <ul className={styles.specList} {...createDataAttributes({
      test: SPARTAN_PRODUCT_ENGINE_TRACKING.itemSpecList(index)
    })}>{engine.specs.map((spec, specIndex) => <li key={[spec.label, specIndex].join("-")} className={SpartanProductEngineSpecStyled({
        theme,
        className: styles.specItem
      })} {...createDataAttributes({
        test: SPARTAN_PRODUCT_ENGINE_TRACKING.itemSpec(index, specIndex)
      })}><div aria-hidden={true} className={styles.specBackground} /><div className="relative min-w-0"><p className={SpartanProductEngineSpecLabelStyled({
            theme
          })} dangerouslySetInnerHTML={{
            __html: spec.label
          }} {...createDataAttributes({
            test: SPARTAN_PRODUCT_ENGINE_TRACKING.itemSpecLabel(index, specIndex)
          })} /><p className={styles.specValueLine}><SharedAnimatedValue key={active ? "active" : "idle"} value={spec.value} animateOnEnter={active} direction={spec.unit === SPARTAN_PRODUCT_ENGINE_SPEC_UNITS.fuelEconomy ? "horizontal" : "auto"} className={SpartanProductEngineSpecValueStyled({
              theme
            })} {...createDataAttributes({
              test: SPARTAN_PRODUCT_ENGINE_TRACKING.itemSpecValue(index, specIndex)
            })} /><span className={SpartanProductEngineSpecUnitStyled({
              theme
            })} {...createDataAttributes({
              test: SPARTAN_PRODUCT_ENGINE_TRACKING.itemSpecUnit(index, specIndex)
            })}>{spec.unit}</span></p></div></li>)}</ul>;
    $[30] = active;
    $[31] = engine.specs;
    $[32] = index;
    $[33] = theme;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t13 || $[36] !== t14 || $[37] !== t3) {
    t15 = <div {...t3}>{t13}{t14}</div>;
    $[35] = t13;
    $[36] = t14;
    $[37] = t3;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  return t15;
};